var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('v-progress-linear',{attrs:{"color":"red darken-2","top":"","fixed":"","active":_vm.isLoading,"indeterminate":true}}),_c('v-main',[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }